import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Helmet } from "react-helmet";

import "./style.scss";
import { MODALS } from "../../general/Modal/constants";
import {
  getKnowledgestackWeekendBytesDetail,
  clearInformationDetail,
  knowledgeStackSubscription,
} from "./actions";
import NoContent from "../../general/NoContent";
import { formDataGenerator, getLang } from "../../../../utils/common";
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  // TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
  LinkedinShareButton,
  LinkedinIcon,
} from "react-share";

class WeekendDetailInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      infoNodeId: "",
      checked: false,
      errors: "",
      seconds: 0,
      enableResendBtn: false,
      enableSend: true,
      arnData: true,
      isOtpSent: false,
      // isOpen: false,
      share: false,
      cardId: -1,
      isOpenshare: false,
      successMessage: 0,
      email: "",
    };
    this.errors = {};
    this.validationSchema = {
      email: {
        required: true,
        pattern: /^\w+([-+.']\w+)*@[A-Za-z\d]+\.com$|.in$/,
      },
    };

    this.formValues = {
      email: "",
    };
  }

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();
    const { email } = this.state;
    const { informationDetail } = this.props;

    // Perform your form submission logic here
    if (this.validateForm()) {
      // Your form submission code here
      let payload = {
        email: email,
        type: "Weekend Bytes",
        article: informationDetail && informationDetail.content && informationDetail.content.page_title ? informationDetail.content.page_title : '',
      };
      this.props.knowledgeStackSubscription(formDataGenerator(payload));
    }
  };

  validateForm = () => {
    const { email } = this.state;
    const errors = {};

    if (!email.match(this.validationSchema.email.pattern)) {
      errors.email = "Email is not correct";
    }

    if (!email) {
      errors.email = "Please Enter your address details";
    }

    this.setState({ errors });

    return Object.keys(errors).length === 0;
  };
  handleClick = (key) => {
    this.setState({ cardId: key });
    if (this.state.cardId == -1 || this.state.cardId === key)
      this.setState((prevState) => ({ share: !prevState.share }));
    this.setState({ share: true });
  };
  // addTodo = () => {
  //   this.setState({ share: false });
  // };
  shareDropDown = () => {
    this.setState((prevState) => ({ isOpenshare: !prevState.isOpenshare }));
  };
  handleClickOutshare = (event) => {
    if (this.shareRef && !this.shareRef.contains(event.target)) {
      this.setState({ isOpenshare: false });
    }
  };

  componentDidMount = () => {
    this.loadHandler();
    window.scrollTo(0, 0);
    // document.addEventListener("click", this.handleClickOut);
    document.addEventListener("click", this.handleClickOutshare);

  };
  componentDidUpdate = () => {
    this.collectFormResponse();
  };
  // eslint-disable-next-line react/sort-comp
  componentWillUnmount() {
    this.props.clearInformationDetail();
    // document.removeEventListener("click", this.handleClickOut);
    document.removeEventListener("click", this.handleClickOutshare);

  }
  componentWillReceiveProps(nextProps) {
    const {
      getKnowledgestackWeekendBytesDetail,
      informationDetail,
      history: { location },
    } = this.props;
    let nodeId = nextProps.location.pathname.split("/");
    if (
      this.state.infoNodeId != "" &&
      this.state.infoNodeId != nodeId[nodeId.length - 1]
    ) {
      getKnowledgestackWeekendBytesDetail({}, nodeId[nodeId.length - 1]);
      this.setState({
        infoNodeId: nodeId[nodeId.length - 1],
      });
    }
  }

  loadHandler = async () => {
    const {
      getKnowledgestackWeekendBytesDetail,
      location: { pathname },
    } = this.props;
    let nodeId = pathname.split("/");
    // if(Object.keys(this.props.informationDetail).length==0 ){
    await getKnowledgestackWeekendBytesDetail({}, nodeId[nodeId.length - 1]);
    this.setState({
      infoNodeId: nodeId[nodeId.length - 1],
    });

    const { openPopup, informationDetail } = this.props;

    // if (
    //   informationDetail &&
    //   document.getElementsByClassName("openModal").length > 0
    // ) {
    //   document.getElementsByClassName("openModal")[0].onclick = (event) => {
    //     event.preventDefault();
    //     openPopup(MODALS.ACCOUNT_STATEMENT, {
    //       modalClass: "account-statement",
    //       heading: "Account Statement",
    //     });
    //   };
    // }
    // }
  };
  collectFormResponse = () => {
    const { subscriptionData } = this.props;

    if (subscriptionData && this.state.successMessage == 0) {
      this.setState({ successMessage: 1 });
    }
  };
  // toggleDropDown = () => {
  //   this.setState((prevState) => ({ isOpen: !prevState.isOpen }));
  // };

  // handleClickOut = (event) => {
  //   if (this.dropdownRef && !this.dropdownRef.contains(event.target)) {
  //     this.setState({ isOpen: false });
  //   }
  // };

  render() {
    const { getInformationContent, informationDetail, online, fundName } = this.props;

    const { infoNodeId, successMessage, email, errors, isOpenshare,
      // isOpen
    } = this.state;
    let {
      location: { pathname },
    } = this.props;

    let show_form = pathname.includes("mf-whatsapp-service-distributors");
    if (fundName) {
      var url = window.location.href;
      url = url + "/" + fundName;
    }
    let shareUrl =
      __CLIENT__ && fundName ? url : __CLIENT__ ? window.location.href : "";
    return (
      informationDetail && (
        <div className="wrapper">
          <div className="information">
            {informationDetail && informationDetail.meta && (
              <Helmet>
                <title>{informationDetail.meta.title}</title>
                <meta
                  name="description"
                  content={informationDetail.meta.description}
                />
                <meta name="keywords" content={informationDetail.meta.keywords} />
                <meta
                  property="og:title"
                  content={informationDetail.meta.og_title}
                />
                <meta
                  property="og:description"
                  content={informationDetail.meta.og_description}
                />
              </Helmet>
            )}
            {/* <SecondaryNav {...this.props} title={informationDetail.title} className='new-website'/> */}
            <section className="aboutHead aboutdiv">
              <div className="container">
                <div className="d-flex dropdowncls">
                  <div
                    className="dropdown me-auto"
                    // ref={(dropdownRef) => (this.dropdownRef = dropdownRef)}
                  >
                    <div id="dropdownMenuLink" 
                      // onClick={this.toggleDropDown}
                    >
                      <h3 className="detailhead">
                        <span> Weekend </span>Bytes
                        {/* <img
                          className="ms-2"
                          src="/images/New/redDownArrow.svg"
                          alt="redDownArrow"
                        /> */}
                      </h3>
                    </div>

                    {/* {isOpen && (
                      <ul
                        className="dropdown-body"
                        aria-labelledby="dropdownMenuLink"
                      >
                        <li>
                          <a
                            className="dropdown-item fw-bold"
                            href="/insights/md-ceo-desk"
                          >
                            Message from MD & CEO'S Desk
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item fw-bold"
                            href="/insights/talking-points"
                          >
                            Talking Points
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item fw-bold"
                            href="/insights/monthly-musings"
                          >
                            Monthly Musings
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item fw-bold"
                            href="/insights/yearbook"
                          >
                            Yearbook
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item fw-bold"
                            href="/insights/webinar"
                          >
                            Webinars
                          </a>
                        </li>
                        <li>
                          <a
                            className="dropdown-item fw-bold"
                            href="/insights/chartscope"
                          >
                            Chartscope
                          </a>
                        </li>
                      </ul>
                    )} */}
                  </div>
                  <nav
                    aria-label="breadcrumb"
                    className="align-self-center breadCrumbCust d-md-inlin"
                  >
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <a href="/">Home</a>
                      </li>
                      <li className="breadcrumb-item">
                        <a href="/knowledge-stack">Knowledge Stack</a>
                      </li>
                      <li
                        className="breadcrumb-item active breadcolor"
                        aria-current="page"
                      >
                        <a href="/knowledge-stack/mf-vault/weekend-bytes">Weekend bytes</a>
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </section>
            <div className="scheme-banner">
              {/* <h1 className="container-930">{informationDetail.title}</h1> */}
            </div>
            {informationDetail.head != null ? (
              <div
                className="product-content container"
                dangerouslySetInnerHTML={{
                  __html: informationDetail.head,
                }}
              />
            ) : (
              show_form && <NoContent />
            )}

            {informationDetail.content &&
            informationDetail.content.image != null ? (
              <div className="container">
                <img
                  src={informationDetail.content.image}
                  alt="image"
                  className="w-100 mt-4"
                />
              </div>
            ) : (
              ""
            )}
            {informationDetail &&
            informationDetail.content &&
            informationDetail.content.page_title != null ? (
              <div className="title-content container">
                <div className="d-flex justify-content-between align-items-center">
                  <h1 className="detailhead">
                    {informationDetail.content.page_title}
                  </h1>
                  <div className="sharedown d-flex">
                    {informationDetail &&
                    informationDetail.content &&
                    informationDetail.content.file_url ? (
                      <a
                        href={
                          informationDetail &&
                          informationDetail.content &&
                          informationDetail.content.file_url
                        }
                        target="_blank"
                      >
                        <div className="share me-4">
                          <svg width="27" height="27" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M32 20.3333C31.558 20.3333 31.1341 20.5089 30.8215 20.8215C30.509 21.134 30.3334 21.558 30.3334 22V28.6666C30.3334 29.1087 30.1578 29.5326 29.8452 29.8452C29.5327 30.1577 29.1087 30.3333 28.6667 30.3333H5.33337C4.89135 30.3333 4.46742 30.1577 4.15486 29.8452C3.8423 29.5326 3.66671 29.1087 3.66671 28.6666V22C3.66671 21.558 3.49111 21.134 3.17855 20.8215C2.86599 20.5089 2.44207 20.3333 2.00004 20.3333C1.55801 20.3333 1.13409 20.5089 0.821529 20.8215C0.508969 21.134 0.333374 21.558 0.333374 22V28.6666C0.333374 29.9927 0.860158 31.2645 1.79784 32.2022C2.73552 33.1399 4.00729 33.6666 5.33337 33.6666H28.6667C29.9928 33.6666 31.2646 33.1399 32.2022 32.2022C33.1399 31.2645 33.6667 29.9927 33.6667 28.6666V22C33.6667 21.558 33.4911 21.134 33.1786 20.8215C32.866 20.5089 32.4421 20.3333 32 20.3333ZM15.8167 23.1833C15.9752 23.335 16.1621 23.454 16.3667 23.5333C16.5662 23.6215 16.7819 23.667 17 23.667C17.2182 23.667 17.4339 23.6215 17.6334 23.5333C17.838 23.454 18.0249 23.335 18.1834 23.1833L24.85 16.5166C25.1639 16.2028 25.3402 15.7772 25.3402 15.3333C25.3402 14.8895 25.1639 14.4638 24.85 14.15C24.5362 13.8361 24.1105 13.6598 23.6667 13.6598C23.2229 13.6598 22.7972 13.8361 22.4834 14.15L18.6667 17.9833V1.99998C18.6667 1.55795 18.4911 1.13403 18.1786 0.821468C17.866 0.508908 17.4421 0.333313 17 0.333313C16.558 0.333313 16.1341 0.508908 15.8215 0.821468C15.509 1.13403 15.3334 1.55795 15.3334 1.99998V17.9833L11.5167 14.15C11.3613 13.9946 11.1768 13.8713 10.9738 13.7872C10.7708 13.7031 10.5531 13.6598 10.3334 13.6598C10.1136 13.6598 9.896 13.7031 9.69296 13.7872C9.48992 13.8713 9.30544 13.9946 9.15004 14.15C8.99464 14.3054 8.87138 14.4899 8.78728 14.6929C8.70317 14.8959 8.65989 15.1135 8.65989 15.3333C8.65989 15.5531 8.70317 15.7707 8.78728 15.9737C8.87138 16.1768 8.99464 16.3612 9.15004 16.5166L15.8167 23.1833Z" fill="black"/>
                          </svg>
                        </div>
                      </a>
                    ) : (
                      ""
                    )}
                    <div
                      className="share"
                      onClick={() => this.handleClick(0)}
                      ref={(shareRef) => (this.shareRef = shareRef)}
                    >
                      <svg width="27" height="27" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={this.shareDropDown}>
                        <path d="M27 20.3333C26.0153 20.3398 25.0443 20.5644 24.1567 20.9909C23.2691 21.4174 22.487 22.0352 21.8667 22.8L13.3667 18.8833C13.7663 17.6596 13.7663 16.3404 13.3667 15.1167L21.8667 11.2C22.8694 12.4099 24.2672 13.2268 25.8136 13.5064C27.3599 13.786 28.9554 13.5104 30.3183 12.7282C31.6812 11.946 32.724 10.7074 33.2626 9.23123C33.8012 7.755 33.8011 6.13596 33.2622 4.65983C32.7233 3.18371 31.6803 1.94539 30.3172 1.16343C28.9542 0.381476 27.3587 0.106143 25.8124 0.386027C24.2661 0.665911 22.8684 1.48302 21.8659 2.69314C20.8634 3.90327 20.3206 5.42862 20.3333 6.99999C20.3384 7.39704 20.3774 7.79293 20.45 8.18332L11.65 12.2333C10.7118 11.316 9.52375 10.6958 8.23468 10.4507C6.94562 10.2056 5.61287 10.3463 4.40342 10.8552C3.19397 11.3641 2.16161 12.2187 1.43567 13.3118C0.709736 14.4048 0.32251 15.6878 0.32251 17C0.32251 18.3122 0.709736 19.5951 1.43567 20.6882C2.16161 21.7813 3.19397 22.6358 4.40342 23.1448C5.61287 23.6537 6.94562 23.7944 8.23468 23.5493C9.52375 23.3041 10.7118 22.684 11.65 21.7667L20.45 25.8167C20.3774 26.207 20.3384 26.6029 20.3333 27C20.3333 28.3185 20.7243 29.6075 21.4569 30.7038C22.1894 31.8001 23.2306 32.6546 24.4488 33.1592C25.667 33.6638 27.0074 33.7958 28.3006 33.5386C29.5938 33.2813 30.7817 32.6464 31.7141 31.714C32.6464 30.7817 33.2813 29.5938 33.5386 28.3006C33.7958 27.0074 33.6638 25.6669 33.1592 24.4488C32.6546 23.2306 31.8001 22.1894 30.7038 21.4569C29.6075 20.7243 28.3186 20.3333 27 20.3333ZM27 3.66665C27.6593 3.66665 28.3037 3.86215 28.8519 4.22842C29.4001 4.59469 29.8273 5.11529 30.0796 5.72438C30.3319 6.33346 30.3979 7.00368 30.2693 7.65029C30.1407 8.29689 29.8232 8.89083 29.357 9.35701C28.8909 9.82318 28.2969 10.1407 27.6503 10.2693C27.0037 10.3979 26.3335 10.3319 25.7244 10.0796C25.1153 9.82729 24.5947 9.40005 24.2284 8.85189C23.8622 8.30372 23.6667 7.65926 23.6667 6.99999C23.6667 6.11593 24.0179 5.26809 24.643 4.64296C25.2681 4.01784 26.116 3.66665 27 3.66665ZM7.00001 20.3333C6.34074 20.3333 5.69627 20.1378 5.14811 19.7716C4.59994 19.4053 4.1727 18.8847 3.92041 18.2756C3.66812 17.6665 3.6021 16.9963 3.73072 16.3497C3.85934 15.7031 4.17681 15.1091 4.64298 14.643C5.10916 14.1768 5.7031 13.8593 6.34971 13.7307C6.99631 13.6021 7.66653 13.6681 8.27562 13.9204C8.88471 14.1727 9.4053 14.5999 9.77157 15.1481C10.1378 15.6962 10.3333 16.3407 10.3333 17C10.3333 17.884 9.98215 18.7319 9.35703 19.357C8.73191 19.9821 7.88406 20.3333 7.00001 20.3333ZM27 30.3333C26.3407 30.3333 25.6963 30.1378 25.1481 29.7716C24.5999 29.4053 24.1727 28.8847 23.9204 28.2756C23.6681 27.6665 23.6021 26.9963 23.7307 26.3497C23.8593 25.7031 24.1768 25.1091 24.643 24.643C25.1092 24.1768 25.7031 23.8593 26.3497 23.7307C26.9963 23.6021 27.6665 23.6681 28.2756 23.9204C28.8847 24.1727 29.4053 24.5999 29.7716 25.1481C30.1378 25.6962 30.3333 26.3407 30.3333 27C30.3333 27.884 29.9822 28.7319 29.357 29.357C28.7319 29.9821 27.8841 30.3333 27 30.3333Z" fill="black"/>
                      </svg>
                      {isOpenshare ? (
                        <>
                          {this.state.share && this.state.cardId === 0 && (
                            <div>
                              <div
                                className="social-shares visible"
                              >
                                <ul>
                                  <li>
                                    <FacebookShareButton url={shareUrl}>
                                      <FacebookIcon size={25} round={true} />
                                    </FacebookShareButton>
                                  </li>
                                  {this.props.noTwitter ? (
                                    ""
                                  ) : (
                                    <li className='newXicon'>
                                      <TwitterShareButton url={shareUrl}>
                                        {/* <TwitterIcon size={25} round={true} /> */}
                                        <img src="/images/New/twitter-02.png" alt="twitter" className='Xicon' width={25} height={25} />
                                      </TwitterShareButton>
                                    </li>
                                  )}
                                  <li>
                                    <LinkedinShareButton
                                      url={shareUrl}
                                      title={"HDFC"}
                                      separator=":: "
                                    >
                                      <LinkedinIcon size={25} round={true} />
                                    </LinkedinShareButton>
                                  </li>
                                  <li>
                                    <WhatsappShareButton
                                      url={shareUrl}
                                      title={"HDFC"}
                                      separator=":: "
                                    >
                                      <WhatsappIcon size={25} round={true} />
                                    </WhatsappShareButton>
                                  </li>
                                  <li>
                                    <EmailShareButton url={shareUrl}>
                                      <EmailIcon size={25} round={true} />
                                    </EmailShareButton>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          )}
                        </>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {/* {informationDetail &&
                informationDetail.content &&
                informationDetail.content.before_video ? (
                  <div className="container"
                    dangerouslySetInnerHTML={{
                      __html:
                      informationDetail.content.before_video,
                    }}
                  />
                ) : null}
                {informationDetail &&
                informationDetail &&
                informationDetail.content &&
                informationDetail.content.video_url ? (
                  <div className="container">
                  <ReactPlayer
                    url={
                      "https://www.youtube.com/watch?v=" +
                      informationDetail.content.video_url
                    }
                    controls="true"
                    className="videoplayer"
                  />
                  </div>
                ) : (
                  ""
                )}

                {informationDetail &&
                informationDetail &&
                informationDetail.content &&
                informationDetail.content.after_video ? (
                  <div className="container"
                    dangerouslySetInnerHTML={{
                      __html: informationDetail.content.after_video,
                    }}
                  />
                ) : null} */}
            {informationDetail.body != null ? (
              <div
                className="product-content container"
                dangerouslySetInnerHTML={{
                  __html: informationDetail.body,
                }}
              />
            ) : (
              <NoContent />
            )}
            {informationDetail &&
            informationDetail.earlier_posts &&
            informationDetail.earlier_posts.content &&
            informationDetail.earlier_posts.content.length > 0 ? (
              <div className="container">
                <div className="mdinfo">
                  <h3 className="mb-4 fs">Recommended For You</h3>
                  <div className="row">
                    {informationDetail &&
                    informationDetail.earlier_posts &&
                    informationDetail.earlier_posts.content &&
                    informationDetail.earlier_posts.content.length > 0 ? (
                      informationDetail.earlier_posts.content.map(
                        (recent, index) => (
                          <div className="col-md-4">
                            <a
                              href={`/knowledge-stack/mf-vault/weekend-bytes/${recent.suggestedUrl ? recent.suggestedUrl : ''}`}
                            >
                              <div className="card">
                                <img
                                  className="card-img-top w-100"
                                  src={recent.image && recent.image.url ? recent.image.url :''}
                                  alt={recent.image && recent.image.alt ? recent.image.alt : ""}
                                />
                                <div className="card-body px-0">
                                  <h4 className="card-title mb-0">
                                    {recent.title ? recent.title : ''}
                                  </h4>

                                  <div className="d-flex readcls">
                                    <p>{recent.publishedDate ? recent.publishedDate : ''}</p>
                                    <p>{recent.time ? recent.time : ''}</p>
                                  </div>
                                  <p className="card-text">
                                    {recent && recent.body ? (
                                      <div
                                        dangerouslySetInnerHTML={{
                                          __html: recent.body,
                                        }}
                                      />
                                    ) : null}
                                  </p>
                                </div>
                              </div>
                            </a>
                          </div>
                        )
                      )
                    ) : (
                      <div className="col-md-4">
                        <div className="card">
                          <div className="card-body px-0">
                            <h5 className="card-title mb-0"> No data found.</h5>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="mdinfo container">
              {this.state.successMessage == 0 ? (
                <form onSubmit={this.handleSubmit}>
                  <div className="bg-warning mt-5 mb-5">
                    <div className="row px-3 py-5">
                      <div className="col-md-9 mx-auto">
                        <div>
                          <h3 class="text-center mb-3">
                            Did you find this interesting
                          </h3>
                          <p className="text-center mb-3">
                            Subscribe to get latest updates
                          </p>
                          <div className="row">
                            <div className="col-md-8 mb-3">
                              <div className="form-group">
                                <input
                                  type="text"
                                  name="email"
                                  placeholder="Enter Address"
                                  value={email}
                                  onChange={this.handleInputChange}
                                  className={
                                    "form-control" +
                                    (errors.email ? " is-invalid" : "")
                                  }
                                  autoComplete='off'
                                  aria-autocomplete="none"
                                />
                                {errors.email && (
                                  <div className="invalid-feedback">
                                    {errors.email}
                                  </div>
                                )}
                              </div>
                            </div>
                            <div className="col-md-4 mb-3">
                              <button
                                className="w-100 btn btn-primary"
                                type="submit"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              ) : (
                <div className="bg-warning mt-5 mb-5">
                  <div className="row px-3 py-5 thanks">
                    <div className="col-md-6 mx-auto">
                      <div>
                        <h3 className="text-center mb-3">
                          Did you find this interesting
                        </h3>
                        <p className="text-center mb-3">
                          Subscribe to get latest updates
                        </p>
                        <button className="w-100 btn btn-light" type="button">
                          Thanks For Signing Up
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )
    );
  }
}
const mapStateToProps = (state) => ({
  commonContent: state.commonContent,
  informationDetail: state.informationDetail,
  subscriptionData: state.weekendInformation.weekendSubscription,
});

const mapDispatchToProps = (dispatch) => ({
  getKnowledgestackWeekendBytesDetail: bindActionCreators(
    getKnowledgestackWeekendBytesDetail,
    dispatch
  ),
  clearInformationDetail: bindActionCreators(clearInformationDetail, dispatch),
  knowledgeStackSubscription: bindActionCreators(knowledgeStackSubscription, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WeekendDetailInfo);
